import { Builder, Image as BuilderImage } from "@builder.io/react";
import CustomButton from "components/CustomButton";
import { SIGNUP_LINK } from "components/constants";
import { Gallery, Item } from "react-photoswipe-gallery";
import { toMutable } from "types/common";
import glass from "./images/glass.svg";
import * as styles from "./styles.module.scss";

const inputs = [
    {
        name: "suptitle",
        type: "text",
        defaultValue: "Choose any dimension and any category",
    },
    {
        name: "title",
        type: "text",
        defaultValue: "Unlimited Cross-Analysisof Metrics",
        required: true,
    },
    {
        name: "subtitle",
        type: "longText",
        defaultValue:
            "Obtain a complete overview of your revenue stream, with key metrics: web traffic, invalid traffic, and even IVT and Misclick Rate. We take it a step further by categorizing our metrics into General, Impressions, Page Views, and Sessions for easier navigation and visualization. Using the drag-and-drop option, arrange the metrics in the order you want them to appear.",
        required: true,
    },
    {
        name: "buttonText",
        type: "text",
        defaultValue: "Learn more",
        required: true,
    },
    {
        name: "buttonTo",
        type: "text",
        defaultValue: SIGNUP_LINK,
        required: true,
    },
    {
        name: "switchMagnifier",
        type: "boolean",
        defaultValue: true,
        enum: [
            {
                value: true,
                label: "Yes",
            },
            {
                value: false,
                label: "No",
            },
        ],
    },
    {
        name: "imageOrGif",
        type: "file",
        allowedFileTypes: ["jpg", "png", "jpeg", "gif", "svg"],
    },
    {
        name: "imageOrGifHover",
        type: "file",
        allowedFileTypes: ["jpg", "png", "jpeg", "gif", "svg"],
    },
    {
        name: "imageOrGifAlt",
        type: "text",
        defaultValue: "Gain Bidder Intelligence",
    },
    {
        name: "imageOrGifWidth",
        type: "number",
        defaultValue: 1234,
    },
    {
        name: "imageOrGifHeight",
        type: "number",
        defaultValue: 792,
    },
] as const;
const SliceAndDiceUnlimitedCrossAnalysis: BFC<typeof inputs> = ({
    suptitle,
    title,
    subtitle,
    buttonTo,
    switchMagnifier,
    buttonText,
    imageOrGif,
    imageOrGifHover,
    imageOrGifAlt,
    imageOrGifWidth,
    imageOrGifHeight,
}) => {
    return (
        <>
            <div className="component-wrapper">
                <div className="container ">
                    <div className="row align-items-center gx-5">
                        <div className="col-lg-6 order-lg-1 mt-4 mb-4 mt-lg-0 mb-lg-0">
                            <div className="mask-container  position-relative ">
                                {imageOrGifHover ? (
                                    <img
                                        onMouseOver={e => {
                                            e.currentTarget.src = imageOrGifHover;
                                        }}
                                        onMouseOut={e => {
                                            e.currentTarget.src = imageOrGif!;
                                        }}
                                        src={imageOrGif}
                                        alt={imageOrGifAlt}
                                        className="img-fluid"
                                    />
                                ) : (
                                    //@ts-ignore
                                    <BuilderImage image={imageOrGif} lazy sizes="100%" altText={imageOrGifAlt} />
                                )}
                                {switchMagnifier && !imageOrGifHover && (
                                    <Gallery>
                                        <Item
                                            width={imageOrGifWidth}
                                            height={imageOrGifHeight}
                                            original={imageOrGif}
                                            alt={imageOrGifAlt}
                                        >
                                            {({ ref, open }) => (
                                                // @ts-expect-error
                                                <div className="image_mask" ref={ref} onClick={open}>
                                                    <img src={glass} alt="zoom image" />
                                                </div>
                                            )}
                                        </Item>
                                    </Gallery>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-6 order-2 order-lg-1 mt-5 mt-lg-0">
                            <p className={styles.suptitle}>{suptitle}</p>
                            <h2>{title}</h2>
                            <p className="mb-5">{subtitle}</p>
                            <CustomButton buttonStyle="btn--primary" to={buttonTo}>
                                {buttonText}
                            </CustomButton>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

Builder.registerComponent(SliceAndDiceUnlimitedCrossAnalysis, {
    name: "sliceAndDiceUnlimitedCrossAnalysis",
    inputs: toMutable(inputs),
});
